export {
    getOptionalSourceLanguage,
    getOptionalTargetLanguage,
    getOptionalTranslationDirection,
    getOptionalViewMode,
    getOptionalViewModeByTextLanguage,
    getOppositeOptionalLanguage,
    getReverseTranslationDirection,
    isOptionalTranslationLanguage,
    shouldRetryOptionalTranslation,
    TARGET_LANGUAGE
} from "../translation-optional-direction";

const cyrillicTextPattern = /[\u0400-\u04FF]/;
const sourceLanguageTextPatterns = {
    fr : /[\u00C0\u00C2\u00C6\u00C7\u00C8\u00C9\u00CA\u00CB\u00CE\u00CF\u00D4\u0152\u00D9\u00DB\u0178\u00E0\u00E2\u00E6\u00E7\u00E8\u00E9\u00EA\u00EB\u00EE\u00EF\u00F4\u0153\u00F9\u00FB\u00FF]/,
    pl : /[\u0104\u0105\u0106\u0107\u0118\u0119\u0141\u0142\u0143\u0144\u015A\u015B\u0179\u017A\u017B\u017C]/,
    cs : /[\u010C\u010D\u010E\u010F\u011A\u011B\u0147\u0148\u0158\u0159\u0160\u0161\u0164\u0165\u016E\u016F\u017D\u017E]/,
    sk : /[\u010C\u010D\u010E\u010F\u0139\u013A\u013D\u013E\u0147\u0148\u00D4\u00F4\u0154\u0155\u0160\u0161\u0164\u0165\u017D\u017E]/,
    hu : /[\u0150\u0151\u0170\u0171]/,
    ro : /[\u0102\u0103\u00C2\u00E2\u00CE\u00EE\u0218\u0219\u021A\u021B]/,
    hr : /[\u010C\u010D\u0106\u0107\u0110\u0111\u0160\u0161\u017D\u017E]/,
    bs : /[\u010C\u010D\u0106\u0107\u0110\u0111\u0160\u0161\u017D\u017E]/,
    sl : /[\u010C\u010D\u0160\u0161\u017D\u017E]/,
    sq : /[\u00CB\u00EB\u00C7\u00E7]/
};

export const hasSourceScriptText = (value, language) => {
    const text = String(value || "");
    const sourcePattern = sourceLanguageTextPatterns[language];

    return cyrillicTextPattern.test(text) || !!(sourcePattern && sourcePattern.test(text));
};
